import { render, staticRenderFns } from "./VehiculeEditPage.vue?vue&type=template&id=288f72a4&scoped=true&"
import script from "./VehiculeEditPage.vue?vue&type=script&lang=js&"
export * from "./VehiculeEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f72a4",
  null
  
)

export default component.exports